import React, { useState, useEffect } from 'react';
import { string, array, bool } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Header } from 'semantic-ui-react';
import { ModuleContainer, CTA } from '../';
import { wideMobileBreakpoint } from '../../utils/breakpoints';
import useWindowWidth from '../../hooks/useWindowWidth';

import StyledSelect from '../FormComponents/Select/Select.style';
import { StyledInfoTile, FlexTileContainer } from './InfoTile.style';

function InfoTile({
  title,
  description,
  ctaText,
  dropDownItems,
  ctaLink,
  backgroundImage,
  external,
  defaultDropDownText
}) {
  const [link, setLink] = useState('');
  const [value, setValue] = useState('');

  //If there is cta link to an external site like https://www.google.com set it here.
  // Or else it gets set from the drop down selection.
  useEffect(() => {
    if (dropDownItems && dropDownItems.length === 1 && !ctaLink) {
      // if there is only one dropdownItem we hide the drop down and just show CTA
      setDropDownItemLink(dropDownItems[0]);
    } else if (ctaLink) {
      setLink(ctaLink);
    }
  }, []);

  const setDropDownItemLink = item => {
    setLink(item.partsUrl ? item.partsUrl : item.url);
  };

  const { windowWidth } = useWindowWidth();
  const dropDownId = `search-drop-down_${title.replace(' ', '-')}`;
  return (
    <ModuleContainer backgroundImage={backgroundImage}>
      <FlexTileContainer>
        <div>
          <Header as="h3">
            <FormattedMessage
              id={`tile.title`}
              description="Title for tile"
              defaultMessage={title}
            />
          </Header>
          <p>
            <FormattedMessage
              id={`tile.description`}
              description="Description for title"
              defaultMessage={description}
            />
          </p>
        </div>

        <StyledInfoTile>
          {dropDownItems && dropDownItems.length > 1 && (
            <StyledSelect className="select">
              <label htmlFor={dropDownId}>{defaultDropDownText}</label>
              <select
                id={dropDownId}
                value={value}
                onChange={e => {
                  const item = dropDownItems.find(
                    i => i.name === e.target.value
                  );
                  setValue(e.target.value);
                  setDropDownItemLink(item);
                }}
                className="ui selection dropdown"
              >
                <option
                  value={undefined}
                  data-testid="tile-default-drop-down-text"
                >
                  {windowWidth < wideMobileBreakpoint
                    ? 'Select'
                    : defaultDropDownText}
                </option>
                {dropDownItems.map(item => {
                  return (
                    <option value={item.name} key={item.id}>
                      {item.name}
                    </option>
                  );
                })}
              </select>
            </StyledSelect>
          )}
          <CTA external={external} link={link} flex>
            <FormattedMessage
              id="tile.ctaText"
              description="Call to arms text for tile"
              defaultMessage={ctaText}
            />
          </CTA>
        </StyledInfoTile>
      </FlexTileContainer>
    </ModuleContainer>
  );
}

InfoTile.propTypes = {
  title: string.isRequired,
  description: string.isRequired,
  ctaText: string.isRequired,
  dropDownItems: array,
  external: bool,
  ctaLink: string,
  backgroundImage: string,
  issmallbutton: bool,
  defaultDropDownText: string
};

InfoTile.defaultProps = {
  dropDownItems: null,
  external: false,
  ctaLink: null,
  backgroundImage: null,
  issmallbutton: false,
  defaultDropDownText: null
};

export default InfoTile;



// WEBPACK FOOTER //
// ./src/components/InfoTile/InfoTile.js